<!--首页-->
<template>
  <div>
    <div class="box" style="overflow: scroll !important">
      <div class="huiyi-box-title" v-if="false">我的业务</div>
      <div class="huiyi-top-items" v-if="false">
        <div
          v-rblink="{ name: 'HuiyiApplyList' }"
          class="item1"
          style="position: relative; padding-top: 3px"
        >
          <div class="huiyi-top-item">
            <div class="top-item-title">会议培训</div>
            <img
              class="iocn-huiyi-zhuangshi"
              src="https://static.dierqudao.com/images/cca/icon-huiyi-zhuangshi.png"
              alt
              srcset
            />
          </div>
          <div class="huiyi-item-back-box">
            <div class="huiyi-item-back hui-back-title1">
              {{ row.huiyi_join_count }}场
            </div>
          </div>
        </div>
        <div
          v-rblink="{ name: 'SongpeiApplyList' }"
          class="item2"
          style="position: relative; padding-top: 3px"
        >
          <div class="huiyi-top-item">
            <div class="top-item-title">送培到基层</div>
            <img
              class="iocn-huiyi-zhuangshi"
              src="https://static.dierqudao.com/images/cca/icon-huiyi-zhuangshi.png"
              alt
              srcset
            />
          </div>
          <div class="huiyi-item-back-box">
            <div class="huiyi-item-back hui-back-title2">
              {{ row.huiyi_count }}场
            </div>
          </div>
        </div>
        <div
          v-rblink="{ name: 'CbaApplyList' }"
          class="item3"
          style="position: relative; padding-top: 3px"
        >
          <div class="huiyi-top-item">
            <div class="top-item-title">七彩星级师资培训</div>

            <img
              class="iocn-huiyi-zhuangshi"
              src="https://static.dierqudao.com/images/cca/icon-huiyi-zhuangshi.png"
              alt
              srcset
            />
          </div>
          <div class="huiyi-item-back-box">
            <div class="huiyi-item-back hui-back-title3">0场</div>
          </div>
        </div>
      </div>

      <div class="huiyi-zc flex-start">
        <div class="zc-left" @click="setCurrent(77)">
          <div class="left-title1">政策解读</div>
          <div class="left-title2">官方解读政策</div>
          <div class="left-title3">立即了解</div>
        </div>
        <div class="zc-right">
          <div class="zc-right-top flex-start">
            <div class="right-top1" v-rblink="{name: 'MyExperience'}">
              <div class="right-top-title1" style="color: #996fe9">
                资质查询
              </div>
              <div class="right-top-title2">立即查看</div>
            </div>
            <div class="right-top2" @click="setCurrent(80)">
              <div class="right-top-title1" style="color: #f2a3b8">
                相关文件
              </div>
              <div class="right-top-title2">立即查看</div>
            </div>
          </div>
          <div class="zc-right-bottom" @click="setCurrent(78)">
            <div class="right-bottom-title1" style="color: #6698f8">
              导师展示
            </div>
            <div class="right-bottom-title2">优秀导师展示</div>
            <div class="right-bottom-title3">立即了解</div>
          </div>
        </div>

      </div>
        <div class="huiyi-plan">
          <img style="width:100%" v-rblink="{
                name: 'HuiyiPlan',
                query: {  },
              }" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20220425/user-0/20220425/d05dc136751dae130ee539f4b84f4a9a.png" />
        </div>

			<van-cell-group>
				<van-cell is-link v-rblink="{name:'HuiyiApplyList'}" title="我的会议培训"  :label="'我已报名成功的会议培训'+row.huiyi_join_count+'场'" >
					<template #default>
						<div class="badge" v-if="row.huiyi_count">报名中{{row.huiyi_count}}场</div>
					</template>
				</van-cell> 
				<van-cell is-link v-rblink="{name:'SongpeiApplyList'}" title="我的送培"  :label="'我已报名成功送培'+row.songpei_join_count+'场'" >
					<template #default>
						<div class="badge" v-if="row.songpei_count">报名中{{row.songpei_count}}场</div>
					</template>
				</van-cell> 
			</van-cell-group>
      <div class="huiyi-box-title">报名入口</div>

      <div class="baoming-item-box">
        <div
          class="baoming-item"
          :key="index"
          v-for="(item, index) in row.group_list"
          :style="getBackground(index)"
          @click="onGroupBtn(item, index)"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="huiyi-box-title" v-if="groupRow">{{ groupRow.name }}</div>

      <div class="huiyi-group-item-box">
<!--        <div v-if="groupRow.name != '全部'" class="group-item" @click="goDetail">-->
        <div class="group-item" @click="goDetail">
          <div
            class="group-item-back-box"
            :style="'width:100%;height:1.46rem;background-image: linear-gradient(to right, #ffb42b , #fbca70)'"
          >
            <div class="group-item-taps">我的</div>
            <div class="group-item-num">
              <div class="group-item-num-mine" v-if="groupRow.name == '七彩星级师资培训'">{{row.cba_count}}场</div>
              <div class="group-item-num-mine" v-else-if="groupRow.name == '送培到基层'">{{row.songpei_count}}场</div>
              <div class="group-item-num-mine" v-else>{{row.huiyi_join_count}}场</div>
            </div>
          </div>
          <div class="group-item-name-mine show-three-row" v-if="groupRow.name == '七彩星级师资培训'">
            我的{{ groupRow.name }}
          </div>
          <div class="group-item-name-mine show-three-row" v-else-if="groupRow.name == '送培到基层'">
            我的{{ groupRow.name }}
          </div>
          <div class="group-item-name-mine show-three-row" v-else>
            我的会议培训
          </div>
        </div>
        <div
          class="group-item"
          v-for="(item, i) in groupRow.list"
          :key="i"
          @click="apply(item)"
        >
          <div
            class="group-item-back-box"
            :style="
              'width:100%;height:1.46rem;background-image: linear-gradient(to right, #' +
              item.color[0] +
              ' , #' +
              item.color[1] +
              ');'
            "
          >
            <!-- <div class="group-item-taps" v-if="item.type_name"> -->
              <!-- {{ item.type_name }} -->
            <!-- </div> -->
            <!-- <div class="group-item-taps" v-else>会议</div> -->
            <div class="group-item-taps" v-if="item.group_names">{{item.group_names}}</div>
            <span class="group-item-str">{{ item.date_str }} 
            </span>
            <span class="group-item-location">
              {{item.province}}{{item.city}}
            </span>
            <!--            <div class="group-item-status" v-if="item.status_name">{{item.status_name}}</div>-->
            <div class="group-item-status" v-if="item.is_pass">结束</div>
            <div class="group-item-status" v-else>进行中</div>
          </div>
          <div class="group-item-name show-three-row">{{ item.name }}</div>
          <van-tag v-if="item.onlycity==1" type="warning">仅限 {{item.province}}{{item.city}}参加</van-tag>
          <van-tag v-else-if="item.onlyprovince==1" type="warning">仅限 {{item.province}}参加</van-tag>
        </div>
      </div>

      <div v-if="currentIndex == 0"></div>
      <div
        v-else-if="
          currentIndex == 1 ||
          currentIndex == 2 ||
          currentIndex == 3 ||
          currentIndex == 4
        "
      >
        <div class="more-box" v-if="huiyiList.length > 0">
          <div class="train-box flex-between" style="flex-wrap: wrap">
            <div
              class="train-items"
              v-for="(row, index) in huiyiList"
              v-rblink="{
                name: 'HuiyiApplyFormStep1',
                query: { saiqu_id: row.id },
              }"
            >
              <div
                class="train-items-top items-top1"
                :style="
                  'background-image: linear-gradient(to right, #' +
                  row.color[0] +
                  ' , #' +
                  row.color[1] +
                  ');'
                "
              >
                <div>
                  <div class="train-items-top-city">{{ row.location }}</div>
                  <div class="train-items-top-time">{{ row.date_str }}</div>
                </div>
                <!--<div class="train-sing-up-btn">报名</div>-->
              </div>
              <div class="train-items-title">{{ row.name }}</div>
              <div class="flex-between">
                <div class="train-items-time">{{ row.startdate }}</div>
                <div class="train-items-address">
                  {{ row.province }}·{{ row.city }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-empty v-else description="暂无场次" />
      </div>
      <div v-else-if="currentIndex > 10">
        <div class="box" v-if="news_list.length > 0">
          <!--<van-pull-refresh v-model="isLoading" @refresh="onRefresh">-->
          <!--<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">-->
          <div
            v-for="(row, i) in news_list"
            :key="i"
            v-rblink="{ name: 'NewsDetail', query: { id: row.id } }"
          >
            <!-- 无图 style==1 -->
            <NewsItem1 :row="row" v-if="row.pics.length == 0"></NewsItem1>
            <!-- 有图 style==2 -->
            <NewsItem2 :row="row" v-if="row.pics.length == 1"></NewsItem2>
            <!-- 视频 style==3 -->
            <NewsItem3 v-if="false"></NewsItem3>
            <!-- 多图 style==4 -->
            <NewsItem4 :row="row" v-if="row.pics.length > 1"></NewsItem4>
          </div>
          <!--</van-list>-->
          <!--</van-pull-refresh>-->
        </div>

        <van-empty v-else description="暂无内容" />
      </div>

      <div class="more-box" v-if="false" v-show="row.doing.length > 0">
        <div class="more-active">
          <div style="display: flex; align-items: center">
            <div class="solid solid2"></div>
            <span class="more-title">正在报名</span>
          </div>
          <!--<div style="display:flex;align-items: center">-->
          <!--<div class="more-right">更多</div>-->
          <!--<img src="../../../assets/images/arrow.png" alt="" srcset="">-->
          <!--</div>-->
        </div>
        <div
          style="display: flex; justify-content: space-between; display: none"
        >
          <div class="more-items">
            <img
              src="../../../assets/images/pic-homepage-Meetings-and-training1.png"
              alt
              srcset
            />
            <span>首次注册</span>
          </div>
          <div class="more-items">
            <img
              src="../../../assets/images/pic-homepage-Meetings-and-training2.png"
              alt
              srcset
            />
            <span>报名申请</span>
          </div>
          <div class="more-items">
            <img
              src="../../../assets/images/pic-homepage-Meetings-and-training3.png"
              alt
              srcset
            />
            <span>咨询查询</span>
          </div>
        </div>

        <div class="main-solid"></div>
        <div class="train-box flex-between" style="flex-wrap: wrap">
          <div
            :key="index"
            class="train-items"
            v-for="(row, index) in row.doing"
            v-rblink="{
              name: 'HuiyiApplyFormStep1',
              query: { saiqu_id: row.id },
            }"
          >
            <div
              class="train-items-top items-top1"
              :style="
                'background-image: linear-gradient(to right, #' +
                row.color[0] +
                ' , #' +
                row.color[1] +
                ');'
              "
            >
              <div>
                <div class="train-items-top-city">{{ row.location }}</div>
                <div class="train-items-top-time">{{ row.date_str }}</div>
              </div>
              <!--<div class="train-sing-up-btn">报名</div>-->
            </div>
            <div class="train-items-title">{{ row.name }}</div>
            <div class="flex-between">
              <div class="train-items-time">{{ row.startdate }}</div>
              <div class="train-items-address">
                {{ row.province }}·{{ row.city }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <LoginDialog
        :show="loginShow"
        @loginSuccess="loginSuccess"
        @loginCancel="loginCancel"
      />
    </div>
  </div>
</template>
<style scoped>
/* @import '../../assets/style/index.css'; */
.show-two-row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.show-three-row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.group-item-status {
  width: 0.64rem;
  height: 0.64rem;
  border-radius: 0.64rem;
  background: #ffffff;
  opacity: 0.79;
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 0.64rem;
  text-align: center;
  overflow: hidden;
}
.group-item-str {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  display: inline-block;
  line-height: 1.46rem;
  text-align: center;
}
.group-item-location{
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  position: absolute;
  /* top: 0; */
  left: 0;
  bottom: 8px;
  right: 0;
  margin: 0 auto;
  display: inline-block; 
  text-align: center;
}
.group-item-num {
  line-height: 1.46rem;
  text-align: center;
}
.group-item-num-mine {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 0.8rem;
  background: #ffffff;
  opacity: 0.79;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 0.8rem;
  text-align: center;
  display: inline-block;
}
.group-item-name {
  margin: 0.1rem 0.38rem 0.1rem 0.1rem;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.group-item-name-mine {
  padding: 0.1rem;
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.group-item-taps {
  position: absolute;
  border-radius: 0 0 8px 0;
  background-image: linear-gradient(to right, #fb7600, #fd9800);
  padding: 0 10px;
  color: #fff;
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.group-item-back-box {
  position: relative;
}
.group-item {
  width: 3.45rem;
  /*height: 2.42rem;*/
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
}
.huiyi-group-item-box {
  margin: 10px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.baoming-item {
  /* background: rgba(222, 150, 40, 0.28); */
  border-radius: 0.29rem;
  /* border: 1px solid #de9628; */
  padding: 0.05rem 0.3rem;
  display: inline-block;
  margin-right: 0.3rem;
  margin-bottom: 0.1rem;
  /* line-height: 0.51rem; */
}
.baoming-item-box {
  padding-left: 10px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.2rem;
}
.right-bottom-title1 {
  height: 0.37rem;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #6698f8;
  line-height: 0.37rem;
  margin-top: 0.16rem;
  margin-left: 0.16rem;
}
.right-bottom-title2 {
  height: 0.33rem;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.33rem;
  margin-left: 0.16rem;
}

.right-bottom-title3 {
  width: 1.12rem;
  height: 0.36rem;
  background: #6698f8;
  border-radius: 0.18rem;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.36rem;
  text-align: center;
  margin-top: 0.1rem;
  margin-left: 0.16rem;
}
.right-top-title1 {
  margin-top: 0.1rem;
  margin-left: 0.1rem;
  height: 0.33rem;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;

  line-height: 0.33rem;
}
.right-top-title2 {
  height: 0.28rem;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.28rem;
  margin-top: 0.1rem;
  margin-left: 0.1rem;
}
.left-title1 {
  height: 0.45rem;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #f19710;
  line-height: 0.45rem;
  margin-top: 0.2rem;
  margin-left: 0.2rem;
}
.left-title2 {
  height: 0.33rem;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.33rem;
  margin-left: 0.2rem;
  margin-top: 2px;
}
.left-title3 {
  width: 1.12rem;
  height: 0.36rem;
  background: #f7b500;
  border-radius: 18rem;
  opacity: 0.76;
  margin-top: 0.2rem;
  margin-left: 0.2rem;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.36rem;
  text-align: center;
}
.zc-left {
  width: 3.22rem;
  height: 3.24rem;
  background: url("https://static.dierqudao.com/images/cca/bg-huiyi-left@2x.png");
  background-repeat: no-repeat;
  background-size: 3.22rem 3.24rem;
}
.right-top1 {
  width: 1.79rem;
  height: 1.57rem;
  background: url("https://static.dierqudao.com/images/cca/bg-huiyi-right-up-left@2x.png");
  background-repeat: no-repeat;
  background-size: 1.79rem 1.57rem;
}
.right-top2 {
  width: 1.79rem;
  height: 1.57rem;
  background: url("https://static.dierqudao.com/images/cca/bg-huiyi-right-up-right@2x.png");
  background-repeat: no-repeat;
  background-size: 1.79rem 1.57rem;
}
.zc-right-bottom {
  width: 3.68rem;
  height: 1.57rem;
  background: url("https://static.dierqudao.com/images/cca/bg-huiyi-right-bottom@2x.png");
  background-repeat: no-repeat;
  background-size: 3.68rem 1.57rem;
  margin-top: 0.1rem;
  overflow: hidden;
}
.zc-right-top {
  justify-content: space-between;
}
.huiyi-zc {
  padding: 10px;
  justify-content: space-between;
}
.huiyi-item-back-box {
  width: 100%;
  position: absolute;
  top: -3px;
  height: 0.24rem;
}
.huiyi-item-back {
  margin: 0 auto;
  width: 0.79rem;
  height: 0.24rem;
  background: url("https://static.dierqudao.com/images/cca/back-huiyi-changci.png");
  background-size: 0.79rem 0.24rem;
  position: relative;
  z-index: 10;
  font-size: 0.2rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 0.24rem;
  text-align: center;
}
.hui-back-title1 {
  color: #50b0ff;
}
.hui-back-title2 {
  color: #57e1ab;
}
.hui-back-title3 {
  color: #d12adf;
}
.iocn-huiyi-zhuangshi {
  width: 0.1rem;
  height: 0.31rem;
  margin-left: 0.23rem;
}
.huiyi-top-item {
  display: flex;
  align-items: center;
  padding: 0.24rem 0.2rem;
  border-radius: 0.42rem;
  justify-content: space-between;
}
.top-item-title {
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.huiyi-top-items {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.huiyi-top-items .item1 {
  border-radius: 0.42rem;
  background: linear-gradient(226deg, #4bc1ff 0%, #5599ff 100%);
}
.huiyi-top-items .item2 {
  border-radius: 0.42rem;
  background: linear-gradient(315deg, #5ee7b3 0%, #29b778 100%);
}
.huiyi-top-items .item3 {
  border-radius: 0.42rem;
  background: linear-gradient(225deg, #ed34de 0%, #b620e0 100%, #ae5cef 100%);
}
.huiyi-box-title {
  margin: 10px 10px;
  height: 0.45rem;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 0.45rem;
  margin-bottom: 0;
}

.row4 {
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-between;*/
  margin: 10px 10px;
  /*flex-wrap: wrap;*/
}
.row4 img {
  width: 100%;
  float: left;
  width: calc(25% - 10px);
  margin: 0 10px 10px 0;
}
.row4 img.current {
  box-shadow: 0px 0px 10px 0px rgba(119, 175, 255, 1);
}
.more-box {
  width: 6.25rem;
  background: #fff;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
  padding: 20px;
}
.more-active {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.solid1 {
  background-image: linear-gradient(#1eb2ff, #2b7aff);
}
.solid2 {
  background-image: linear-gradient(#ffc934, #ff9c00);
}
.solid3 {
  background-image: linear-gradient(#ff7d6f, #ff433e);
}
.solid4 {
  background-image: linear-gradient(#e77eff, #8b5afd);
}
.solid5 {
  background-image: linear-gradient(#ffc934, #ff9c00);
}
.solid6 {
  background-image: linear-gradient(#1eb2ff, #2b7aff);
}
.solid7 {
  background-image: linear-gradient(#ff7d6f, #ff4540);
}

.more-items {
  width: 2.02rem;
  position: relative;
  display: flex;
  align-items: center;
}
.more-items img {
  width: 2.02rem;
}
.more-items span {
  font-size: 14px;
  font-family: "PingFangSC-Regular,PingFang SC";
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  left: 7px;
}

.more-active .solid {
  width: 4px;
  height: 25px;
  border-radius: 4px;
  margin-right: 5px;
}
.more-active .more-title {
  color: #333;
  font-size: 16px;
  height: 25px;
  line-height: 25px;
}
.more-active .more-right {
  color: #333;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}
.more-active img {
  margin-left: 5px;
  width: 5.5px;
  height: 10px;
}
.main-solid {
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin: 10px 0;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
.fontFamily {
  font-family: "PingFangSC-Regular,PingFang SC";
}

.train-items {
  width: 3.08rem;
  margin-bottom: 0.3rem;
}

.items-top1 {
  background-image: linear-gradient(to right, #01ea9b, #8dec9d);
}
.items-top2 {
  background-image: linear-gradient(to right, #2b7aff, #1eb2ff);
}

.train-items-top {
  width: 3.08rem;
  height: 1.68rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.train-items-top-city {
  color: #fff;
  font-size: 28px;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
}
.train-items-top-time {
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
}
.train-sing-up-btn {
  width: 48px;
  height: 26px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  font-family: "PingFangSC-Medium,PingFang SC";
  border: 1px solid #fff;
  border-radius: 26px;
  text-align: center;
  line-height: 26px;
}
.train-items-title {
  color: #333;
  font-size: 14px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
  margin: 5px 0;
}
.train-items-time,
.train-items-address {
  color: #595757;
  font-size: 12px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
}
.train-items-address {
  margin-right: 10px;
}

.box {
  background: #f8f8f8;
  margin-bottom: 50px;
  overflow: hidden;
  min-height: 100vh;
}
</style>

<script>
import Vue from "vue";
import TabBar from "@/components/TabBar.vue";
import LoginDialog from "@/components/LoginDialog.vue";
import { NoticeBar, Collapse, CollapseItem, Empty } from "vant";

import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";

Vue.use(NoticeBar);
Vue.use(CollapseItem);
Vue.use(Collapse);
Vue.use(Empty);

export default {
  name: "HuiyiIndexTwo",
  components: {
    TabBar,
    LoginDialog,
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
  },
  data: function () {
    return {
      currentIndex: 0,
      huiyiAcitiveCs: [],
      loginShow: false,
      showTabBar: false,
      row: {
        group_list: [],
        news_list: [],
        doing: [],
        going: [],
        pass: [],
        songpei_count:0,
        huiyi_count:0, 
        songpei_join_count:0,
        huiyi_join_count:0, 
      },
      catelist: [],

      groupIndex: 0,
      groupRow: {},
    };
  },
  filter: {},
  computed: {
    huiyiList() {
      let that = this;
      return this.row.doing.filter((item) => {
        return item.gametype == that.currentIndex;
      });
    },
    news_list() {
      let that = this;
      if (that.currentIndex < 10) {
        return [];
      }
      return this.row.news_list["i" + that.currentIndex];
    },
  },
  mounted() {
    document.title = "会议培训";
    this.showTabBar = window.isApp() ? false : true;
    let that = this;
    that.$api.get(
      "/api/cms/catelist",
      {
        parent_id: 72,
      },
      (res) => {
        that.catelist = res.data;
      },
      (res) => {
        Toast(res.msg);
      }
    );

    this.fetch();
  },
  destroyed() {},
  methods: {
    onGroupBtn(item, index) {
      this.groupIndex = index;
      this.groupRow = item;
    },
    goDetail() {
        switch (this.groupRow.name) {
          case '七彩星级师资培训':
            rbLink({
              name: 'CbaApplyList'
            })
            break;
            case '送培到基层':
            rbLink({
              name: 'SongpeiApplyList'
            })
            break;

          default:
            rbLink({
              name: 'HuiyiApplyList'
            })
            break;
        }
    },
    getBackground(index) {
      let back = "";
      let colors = [
        { color: "222, 150, 40," },
        { color: "199, 189, 189," },
        { color: "165, 131, 230," },
        { color: "226, 166, 182," },
      ];
      console.log(index, this.groupIndex);
      if (index == this.groupIndex) {
        back =
          "background:rgba(" +
          colors[index % 4].color +
          " 0.28);border:1px solid rgba(" +
          colors[index % 4].color +
          " 1)";
      } else {
        back =
          "background:rgba(" +
          colors[index % 4].color +
          " 0.28);border:1px solid #f8f8f8";
      }
      return back;
    },
    setCurrent(index) {
      rbLink({
        name: "NewsList",
        query: {
          cate_id: index,
        },
      });
      return;
      console.log(index);
      this.currentIndex = this.currentIndex == index ? 0 : index;
    },
    fetch() {
      let that = this;
      this.$api.get(
        "/api/huiyi/indexData",
        {},
        (res) => {
          console.log(res);
          that.row = res.data;
          if (res.data.group_list.length > 0) {
            this.groupRow = res.data.group_list[0];
          }
        },
        (res) => {
          console.log("没有登录");
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    apply(row) {
      if (row.type == "songpei") {
        rbLink({ name: "SongpeiApplyFormBasic", query: { saiqu_id: row.id } });
      } else if (row.type == "cba") {
        rbLink({ name: "CbaApplyFormBasic", query: { station_id: row.id } });
      } else {
        rbLink({ name: "HuiyiApplyFormStep1", query: { saiqu_id: row.id } });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// HuiyiIndexTwo.vue?65050903